// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'
import {utils} from './common/common'
Vue.use(element)

import CommRec from './components/CommRec.vue';
import eventBus from "../../../../../../util/eventBus";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
            console.log('-----update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.getZeroTime = (val) =>{
                let time = val ? new Date(val) : new Date();
                return new Date(time.getFullYear() + '/' + (time.getMonth()+1) + '/' + time.getDate()).getTime();
            }
            Vue.prototype.invoke = (eventName, args)=>{
                invoke(eventName, args)
            }
            Vue.prototype.cutString = utils.cutString
            Vue.prototype.dateFormat = utils.dateFormat
            Vue.prototype.getBrowserName = utils.getBrowserName

            new Vue({
                el: model.dom,
                template: '<CommRec :themeNum="themeNum" :lang="lang" :onlyShowAtinput="isOnlyShowAtInput" :cusParam_release="cusParam_release" :cusParam_commlistdata="cusParam_commlistdata" :cusParam_searchPeoples="cusParam_searchPeoples" :cusParam_srcollBottom="cusParam_srcollBottom" :cusParam_clearInputText="cusParam_clearInputText" :cusParam_pageOpenType="cusParam_pageOpenType" />',
                components: {
                    CommRec
                },
                data: {
                    themeNum:"#5582F3",
                    lang:"zh_CN",
                    isOnlyShowAtInput:false,
                    cusParam_release:0,
                    cusParam_commlistdata:[],
                    cusParam_pageOpenType:"",
                    cusParam_searchPeoples:[],
                    cusParam_srcollBottom:0,
                    cusParam_clearInputText:""
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    //初始化控件配置信息
                    if (props.configItems) {
                        for (let x in props.configItems) {
                            this[props.configItems[x].key] = props.configItems[x].value;
                        }
                    }
                    this.isOnlyShowAtInput = this.isOnlyShowAtInput === 'true' ? true : false;
                    if(props.themeNum){this.themeNum = props.themeNum;}
                    if(props.lang){this.lang = props.lang;}
                    if(props.data && props.data.hasOwnProperty('cusParam_commlistdata') && props.data.cusParam_commlistdata){
                        this.cusParam_commlistdata = props.data.cusParam_commlistdata ? JSON.parse(props.data.cusParam_commlistdata) : [];
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if(props.themeNum){this.themeNum = props.themeNum;}
                        if(!props.data){return}
                        if(props.data.hasOwnProperty('cusParam_release') && props.data.cusParam_release){
                             this.cusParam_release = props.data.cusParam_release
                        }
                        if(props.data.hasOwnProperty('cusParam_commlistdata') && props.data.cusParam_commlistdata){
                            this.cusParam_commlistdata = props.data.cusParam_commlistdata ? JSON.parse(props.data.cusParam_commlistdata) : [];
                        }
                        if(props.data.hasOwnProperty('cusParam_pageOpenType') && props.data.cusParam_pageOpenType){
                            this.cusParam_pageOpenType = props.data.cusParam_pageOpenType;
                        }
                        if(props.data.hasOwnProperty('cusParam_searchPeoples') && props.data.cusParam_searchPeoples){
                            this.cusParam_searchPeoples = props.data.cusParam_searchPeoples ? JSON.parse(props.data.cusParam_searchPeoples) : [];
                        }
                        if(props.data.hasOwnProperty('cusParam_srcollBottom') && props.data.cusParam_srcollBottom){
                            this.cusParam_srcollBottom = props.data.cusParam_srcollBottom;
                        }
                        if(props.data.hasOwnProperty('cusParam_clearInputText') && props.data.cusParam_clearInputText){
                            this.cusParam_clearInputText = props.data.cusParam_clearInputText;
                        }

                    })
                },
                methods: {

                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('commRecord', MyComponent,{
        isMulLang: true
    })
})(window.KDApi)
